import axios from "./axios-config";

export const getAllTemplates = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/kavenegar-templates?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}

export const getSingleTemplate = async (id) => {

    let { data } = await axios.get(`/super-admin/kavenegar-templates/` + id)
    return data;

}
export const deleteSingleTemplate = async (id) => {
    let { data } = await axios.delete(`/super-admin/kavenegar-templates/` + id)
    return data;
}

export const updateSingleTemplates = async (updateData) => {

    let { data } = await axios.post(`/super-admin/kavenegar-templates/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleTemplates = async (storeData) => {

    let { data } = await axios.post(`/super-admin/kavenegar-templates`, storeData)
    return data
}


// export const getUserTemplates = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Templates/all/blogs`, data)
//     return data;
// }

// export const getWorkshopTemplates = async (data) => {
//     try {
//         let response = await axios.post(`/super-admin/Templates/all/kavenegar-templates`, data)
//         return (response.data);
//     } catch (error) {
//         return (error);
//     }
// }

